module.exports = __webpack_public_path__ + "static/media/icn-campaigns-selected.5da452d5.svg";